import { takeLatest } from "redux-saga/effects";
import {
  SAVE_RULE_REQUEST,
  UPDATE_RULE_REQUEST,
  GET_RULES_FOR_APPLICATION_CONNECTION_REQUEST,
  GET_RULE_FOR_APPLICATION_CONNECTION_REQUEST,
  ENABLE_DISABLE_RULE_REQUEST,
  DELETE_RULE_REQUEST,
  PARSE_RULE_REQUEST,
} from '../constants';
import {
  saveRuleRequestSaga,
  updateRuleRequestSaga,
  getRulesForApplicationConnectionRequestSaga,
  getRuleForApplicationConnectionRequestSaga,
  enableDisableRuleRequestSaga,
  deleteRuleRequestSaga,
  parseRuleRequestSaga,
} from './receiptRulesSaga';

export function* receiptRulesSaga() {
  yield takeLatest(SAVE_RULE_REQUEST, saveRuleRequestSaga);
  yield takeLatest(UPDATE_RULE_REQUEST, updateRuleRequestSaga);
  yield takeLatest(
    GET_RULES_FOR_APPLICATION_CONNECTION_REQUEST,
    getRulesForApplicationConnectionRequestSaga
  );
  yield takeLatest(
    GET_RULE_FOR_APPLICATION_CONNECTION_REQUEST,
    getRuleForApplicationConnectionRequestSaga
  );
  yield takeLatest(ENABLE_DISABLE_RULE_REQUEST, enableDisableRuleRequestSaga);
  yield takeLatest(DELETE_RULE_REQUEST, deleteRuleRequestSaga);
  yield takeLatest(PARSE_RULE_REQUEST, parseRuleRequestSaga);
}